import numeral from 'numeral';

export const formatDollarValue = (value) => {
  return numeral(value).divide(100).format('$0,0[.]00');
};

export const formatDollars = (value) => {
  return numeral(value).format('$0,0[.]00');
};

export const isAnnually = (interval, intervalCount) => {
  return interval === 'year' && intervalCount === '1';
};

export const isQuarterly = (interval, intervalCount) => {
  return interval === 'month' && intervalCount === '3';
};

export const getTabResource = (onboardingStepResource, tabName) => {
  return onboardingStepResource.attr('tabs').resources().list().find((resource) => {
    return resource.type() === tabName;
  });
};
